import { render } from "./ConfirmSizeTyreOptions.vue?vue&type=template&id=517d0ef9"
import script from "./ConfirmSizeTyreOptions.vue?vue&type=script&lang=js"
export * from "./ConfirmSizeTyreOptions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__